import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 260,
      height: 230,
      margin: '10px 10px'
    },
    left: {
      background: '#444',
      "& h4": {
        color: '#eee'
      },
      "& hr": {
        margin: '5px auto',
        background: '#fff'
      },
      "& div": {
        color: '#aaa',
      },
      "& p": {
        color: '#ccc',
        fontSize: 13,
        marginBottom: 15
      },
      "& span": {
        margin: '15px 3px 5px 0',
        background: 'lightbule',
        fontSize: 10,
        padding: '1px 3px',
      }
    },
    lefttext: {
      fontSize: 9
    },
    right: {
      background: '#ddd',
      "& p": {
        fontSize: 12,
        marginBottom: 15
      },
    },
    media: {
      height: 100,
      width: 90,
      margin: '20px auto 0'

    },

  }),
);

export default function SearchCard(props) {
  const classes = useStyles();

  return [1, 2, 3, 4, 5, 6].map((item, index) =>
    <Card key={index} className={classes.root} >
      <Grid container spacing={2}>
        <Grid item={true} xs={6} className={classes.left}>
          <CardMedia
            className={classes.media}
            image="/img/ceg.png"
            title=""
          />
          <CardContent>
            <Typography component="h4" align="center">
              Cégnév
            </Typography>
            <Typography align="center" className={classes.lefttext} component="div">
              Budapest
            </Typography>
            <Typography align="center" className={classes.lefttext} component="div">
              +36-70/234-45-77
            </Typography>
            <Divider component="hr" />

            {
              ["követés", "kapcsolat"].map((item, index) => <Paper key={index} component="span">{item}</Paper>)
            }
          </CardContent>
        </Grid>
        <Grid item={true} xs={6} className={classes.right}>
          <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
              This impressive paella is a perfect party dish and a fun meal to cook together with your
              guests. Add 1 cup of frozen peas along with the mussels, if you like.
            </Typography>

          </CardContent>
        </Grid>
      </Grid>
    </Card>
  );
}